import { Component, OnInit, OnDestroy } from "@angular/core";
import {InteractivesService, SubscriptionService} from "../../api/services";
import {
  DropDownItem,
  UserState,
  US_Interactive,
  US_ModifiedInteractive, US_SubHeader,
} from "../../api/models";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import {
  CopyInteractiveDialogComponent,
  CopyInteractiveDialogData,
} from "../../dialogs/copy-interactive-dialog/copy-interactive-dialog.component";
import { DialogResultType } from "../../dialogs/DialogResult";
import {
  ConfirmDialogData,
  ConfirmDialogComponent,
} from "../../dialogs/confirm-dialog/confirm-dialog.component";
import { GlobalApp } from "../../tools/global";
import { Subscription } from "rxjs";
import { UserTypeValue } from "../../api/models-ex/user-type-values";
import {UserStateEx} from "../../api/models-ex/user-state-ex";
import { DropDownSelectDialogComponent } from "../../dialogs/dropdown-select-dialog/dropdown-select-dialog.component";
import {MatLegacySelectChange} from "@angular/material/legacy-select";
import {MatSelectChange} from "@angular/material/select";

@Component({
  selector: "app-prefilter",
  templateUrl: "./pre-filter.component.html",
})
export class PreFilterComponent implements OnInit, OnDestroy {
  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    preFilters: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false,
    hasAiChats: false,
    isValidState: false
  };
  userStateSubscription: Subscription = null;
  subscriptions: US_SubHeader[] = [];
  selectedSubscription: US_SubHeader = null;
  selectedSubscriptionId: number = -1;

  public loadingData = true;

  constructor(
    private subscriptionService: SubscriptionService,
    private app: GlobalApp,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      } else {
        this.loadingData = true;
        this.app.refreshUserState(this.subscriptionService);
      }
    });
  }

  ngOnInit() {
    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;
      this.subscriptions = this.getPreFilterSubscriptions();

      if (this.selectedSubscriptionId > 0) {
        const found = this.subscriptions.find(s => s.subscriptionId === this.selectedSubscriptionId);
        if (found) {
          this.selectedSubscription = found;
        } else {
          this.selectedSubscription = this.subscriptions[0];
          this.selectedSubscriptionId = this.selectedSubscription?.subscriptionId;
        }
      } else {
        this.selectedSubscription = this.subscriptions[0];
        this.selectedSubscriptionId = this.selectedSubscription?.subscriptionId;
      }

      this.loadingData = false;
    });
  }

  ngOnDestroy() {
    if (this.userStateSubscription) {
      this.userStateSubscription.unsubscribe();
    }
  }

  public getPreFilterSubscriptions() {
    let filteredSubscriptions: US_SubHeader[] = [];

    if (this.userState) {
      const seenIds = new Set();

      for (let interact of this.userState.interactives) {
        if (interact.canPreFilter) {
          for (let header of interact.subscriptionHeaders) {
            if (!seenIds.has(header.subscriptionId)) {
              filteredSubscriptions.push(header);
              seenIds.add(header.subscriptionId);
            }
          }
        }
      }
    }

    return filteredSubscriptions;
  }

  protected subscriptionChanged($event: MatLegacySelectChange & MatSelectChange) {
    this.selectedSubscriptionId = this.selectedSubscription.subscriptionId;
  }
}
